import NextLink from 'next/link';

import {AnimatedText, Button} from '#component/base';
import {sprinkles} from '#style/sprinkles';

export const RegisterKitHeader = () => (
  <div
    className={sprinkles({
      colSpan: [4, 6, 10],
      colStart: [1, 2],
      dir: ['col', 'row'],
      flex: 'flex',
      gap: 32,
    })}>
    <div className={sprinkles({dir: 'col', flex: 'flex', gap: 32})}>
      <AnimatedText color="inherit" variant="heading2">
        Discover your TallyAge™
      </AnimatedText>
    </div>
    <div className={sprinkles({dir: 'col', flex: 'flex', gap: 64})}>
      <AnimatedText color="inherit">
        Reveal your epigenetic age and get personalized guidance to live a longer, more vibrant
        life.
      </AnimatedText>
      <div className={sprinkles({dir: ['col', 'row'], flex: 'flex', gap: 16})}>
        <NextLink href="/register" passHref>
          <Button
            as="a"
            className={sprinkles({w: ['full', 'maxContent']})}
            icon="ArrowRight"
            variant="primary-dark">
            Register your test
          </Button>
        </NextLink>

        <NextLink href="/shop" passHref>
          <Button
            as="a"
            className={sprinkles({w: ['full', 'maxContent']})}
            icon="ArrowRight"
            variant="secondary-dark">
            Order now
          </Button>
        </NextLink>
      </div>
    </div>
  </div>
);
